import { createStyles, makeStyles, Theme } from "@material-ui/core";

import { isMobile } from "react-device-detect";
const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		container: {
			width: isMobile ? "100vw" : "900px",
			height: "530px",
		},
	});
});

export function MainVideo() {
	const classes = useStyles();
	return (
		<video
			id="main-video"
			autoPlay={true}
			loop={true}
			muted
			className={classes.container}
		>
			<source
				src="https://batch-32.imgix.net/My Movie 2.mp4"
				type="video/mp4"
			></source>{" "}
		</video>
	);
}
